import React from 'react';
import { PrimaryButton, TextField, MessageBar, MessageBarType, Stack, Spinner, SpinnerSize } from '@fluentui/react';

interface LoginCardProps {
    onLogin: (email: string, password: string) => Promise<void>;
    loginError?: string | null;
    styles: any;
    title?: string;
    subtitle?: string;
    children?: React.ReactNode;
}

export const LoginCard: React.FC<LoginCardProps> = ({ onLogin, loginError, styles, title, subtitle, children }) => {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [submitting, setSubmitting] = React.useState(false);

    async function handleSubmit(e?: React.FormEvent) {
        e?.preventDefault();
        if (!email.trim() || !password) return;
        setSubmitting(true);
        try {
            await onLogin(email.trim(), password);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className={styles.loginCard}>
            <h2 className={styles.loginTitle}>{title ?? 'Administrace systému'}</h2>
            <p className={styles.loginSubtitle}>
                {subtitle ?? 'Pro přístup k administraci se prosím přihlaste.'}
            </p>
            {loginError && (
                <MessageBar messageBarType={MessageBarType.error} style={{ marginBottom: 16 }}>
                    {loginError}
                </MessageBar>
            )}
            <form onSubmit={handleSubmit}>
                <Stack tokens={{ childrenGap: 12 }}>
                    <TextField
                        label="E-mail"
                        type="email"
                        value={email}
                        onChange={(_, v) => setEmail(v || '')}
                        iconProps={{ iconName: 'Mail' }}
                        disabled={submitting}
                        autoComplete="username"
                    />
                    <TextField
                        label="Heslo"
                        type="password"
                        value={password}
                        onChange={(_, v) => setPassword(v || '')}
                        canRevealPassword
                        disabled={submitting}
                        autoComplete="current-password"
                    />
                    <PrimaryButton
                        type="submit"
                        styles={{ root: styles.primaryActionButton }}
                        iconProps={submitting ? undefined : { iconName: 'Signin' }}
                        disabled={submitting || !email.trim() || !password}
                        onRenderText={submitting ? () => (
                            <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                                <Spinner size={SpinnerSize.small} />
                                <span>Přihlašuji…</span>
                            </Stack>
                        ) : undefined}
                    >
                        Přihlásit se
                    </PrimaryButton>
                </Stack>
            </form>
            {children}
        </div>
    );
};
